module.exports = __webpack_public_path__ + "img/diaceutics-brand-gradients-06.1e5815dd.png";